import { Directory } from './directory';

export class Root extends Directory {}
